module.exports = __webpack_public_path__ + "static/media/KaTeX_Size4-Regular.726db3bd.woff";